import styled from "styled-components";

export const VariableGridArea = styled.div`
	display: flex;
	flex-direction: row;
	tbody:hover:active {
		cursor: grab;
	}
`;

export const AreaActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
`;
